import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResultType } from '../../../../../models/enums/result-type.enum';
import { ManagementApiService } from '../../../../../services';
import { SuccessDialogComponent } from 'src/app/shared/info-dialogs/success-dialog/success-dialog.component';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { MatrixRowModel } from '../../../models/templatesModels/matrix-row-model';
@Component({
    selector: 'app-matrix-row-remove',
    templateUrl: './matrix-row-remove.component.html',
    styleUrls: ['./matrix-row-remove.component.scss'],
})
export class MatrixRowRemoveComponent implements OnInit {
    @Input() userMatrixRow: MatrixRowModel;
    @Input() userMatrixRows: MatrixRowModel[];
    @Output() refreshMatrixrow: EventEmitter<boolean> = new EventEmitter();

    tooltip_position = 'above';
    closeResult: string;
    result: ResultType = ResultType.Error;
    isMatrixRowDelete: boolean;

    constructor(
        private modalService: NgbModal,
        private mgmtApi: ManagementApiService,
        private globalEmittersService: GlobalEmittersService,
        private userUtilityService: UserUtilityService
    ) {
        this.isMatrixRowDelete = false;
    }

    async ngOnInit(): Promise<void> {
        // * checking access level
        this.isMatrixRowDelete = await this.userUtilityService.checkUserPermissionDataAndRoute('matrix', userActions.Delete);
    }

    open(content) {
        this.modalService
            .open(content, {
                ariaLabelledBy: 'modal-basic-title',
                backdrop: 'static',
                windowClass: 'my_modal_class',
                size: 'md',
                keyboard: false,
            })
            .result.then(
                (result) => {
                    this.closeResult = `Closed with: ${result}`;
                },
                (reason) => {
                    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
                }
            );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    btnDeleteMatrixRow() {
        this.removeMatrixRow();
        this.modalService.dismissAll();
    }

    async removeMatrixRow() {
        let payload: any = [];
        if (this.userMatrixRows.length <= 0) {
            this.userMatrixRows.push(this.userMatrixRow);
        }
        payload = this.userMatrixRows.map((x) => {
            let obj: any = {};
            obj.userMatrixRowId = x.userMatrixRowId;
            obj.active = false;
            return obj;
        });
        let result = await this.mgmtApi.updateMatrixRow(payload).toPromise();
        if (result.success === true) {
            let dialogRef = this.modalService.open(SuccessDialogComponent, {
                size: 'md',
            });
            dialogRef.componentInstance.message = 'Matrix Row is removed sucessfully!';
            this.globalEmittersService.refreshMatrix.subscribe((res) => {
                if (res === true) {
                    this.refreshMatrixrow.emit(true);
                }
            });
        } else {
            this.userUtilityService.errorModelPopup(result.message);
        }
    }
}
